// v-trim
export default {
  mounted(el) {
    const inputElement = el.querySelector('input') || el;
    inputElement.addEventListener('blur', () => {
      const trimmedValue = inputElement.value.trim();
      console.log(trimmedValue);
      inputElement.dispatchEvent(new CustomEvent('trim-input', { detail: trimmedValue }));
    });
  },
};
